import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useLocalDateTime } from '@/hooks/use-local-date-time'

export const LocalDateTime: FC<{ date: string | Date | null; locale?: Locale }> = ({
  date,
  locale,
}) => {
  const { formatTime } = useLocalDateTime()

  return (
    <span>
      {formatTime({
        date,
        locale,
      })}
    </span>
  )
}
